import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/whiteLabelSettings";

import WhiteLabelSettingsService from "../services/whiteLabelSettings";

class WhiteLabelLoad extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    let appId = this.props.match.params.appId;

    //timeout allows app to finish hydrate cycle before setting new session state.
    //dont love this but needed a quick fix
    setTimeout(() => {
      if (appId === "goodlifept") {
        this.props.getWhiteLabelSettingsForApp(1);
      } else if (appId === "restoreyourcorept") {
        this.props.getWhiteLabelSettingsForApp(2);
      } else if (appId === "madronapt") {
        this.props.getWhiteLabelSettingsForApp(3);
      } else if (appId === "pttech") {
        this.props.getWhiteLabelSettingsForApp(4);
      } else if (appId === "bigheart") {
        this.props.getWhiteLabelSettingsForApp(5);
      } else if (appId === "brownstonept") {
        this.props.getWhiteLabelSettingsForApp(6);
      } else if (appId === "altitudept") {
        this.props.getWhiteLabelSettingsForApp(7);
      } else if (appId === "koiwellness") {
        this.props.getWhiteLabelSettingsForApp(8);
      } else if (appId === "trabeculex") {
        this.props.getWhiteLabelSettingsForApp(9);
      } else if (appId === "shelbysymmetry") {
        this.props.getWhiteLabelSettingsForApp(10);
      } else if (appId === "roots") {
        this.props.getWhiteLabelSettingsForApp(11);
      } else if (appId === "movementmedicinept") {
        this.props.getWhiteLabelSettingsForApp(12);
      }

      this.props.history.push("../");
    }, [2000]);
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1>Loading...</h1>
      </div>
    );
  }
}

function mapStateToProps({ whiteLabelSettings }) {
  return {
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(WhiteLabelLoad);



// WEBPACK FOOTER //
// ./src/layout/WhiteLabelLoad.js